import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as StyledApartmentDetails from '../apartmentDetails.styles';
import { APPLY_FOR_APARTMENT_URL, LOGIN_URL } from '../../../constants/urls';
import { APARTMENT_STAGED_FOR_APPLICATION_TOKEN } from '../../../constants/tokens';
import useAuthentication from '../../../hooks/useAuthentication/useAuthentication';
import { getType } from '../../../helpers/linkResolver/linkResolver';

const ApplicationButton = ({
	hidden,
	id,
	authReducer,
	dispatch
}) => {
	if(hidden) return null;

	const {
		loading, error, authenticated, authDenied
	} = authReducer;

	useAuthentication(loading, error, authenticated, dispatch);

	const onLoginClick = () => {

		localStorage.setItem("grindavik", getType(window.location.pathname) === 'grindavik')
		localStorage[APARTMENT_STAGED_FOR_APPLICATION_TOKEN] = id;
		window.location = LOGIN_URL;
	};

	if(!authenticated && !authDenied) return null;

	const prefix = getType(window.location.pathname) === 'grindavik' ? '/grindavik' : ''
	return (
		<>
			{
				authenticated ? (
					<StyledApartmentDetails.ApplyForApartmentButton
						to={`${prefix}${APPLY_FOR_APARTMENT_URL}${id}`}>
						<span>Sækja um íbúð</span>
					</StyledApartmentDetails.ApplyForApartmentButton>
				) : (
					<StyledApartmentDetails.ApplyForApartmentButton
						as="button"
						onClick={onLoginClick}>
						<span>Skrá mig inn til að sækja um íbúð</span>
					</StyledApartmentDetails.ApplyForApartmentButton>
				)
			}
		</>
	);
};

ApplicationButton.propTypes = {
	id: PropTypes.string.isRequired,
	hidden: PropTypes.bool
};

ApplicationButton.defaultProps = {
	hidden: false
};

const mapStateToProps = ({ authReducer }) => ({
	authReducer
});

export default connect(mapStateToProps)(ApplicationButton);
